/**
 * Reducer for the list of application types from GET /publisher/v2/applications/applicationTypes.
 * Set when products page loads; null when not yet loaded or on API failure.
 */
import { SET_APPLICATION_TYPES } from "../actions/actions";
import { ApplicationTypeDetail } from "../types";

const initialState: ApplicationTypeDetail[] | null = null;

export default (state = initialState, action: { type: string; payload?: ApplicationTypeDetail[] | null }) => {
  switch (action.type) {
    case SET_APPLICATION_TYPES:
      return action.payload !== undefined ? action.payload : state;
    default:
      return state;
  }
};
